<script>
import { list } from '@/api/estado'

export default {
  props: {
    model: {
      type: String,
      default: ''
    }
  },
  watch: {
    model () {
      if (this.model) this.obj = { uf: this.model }
    }
  },
  data () {
    return {
      obj: {}
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ estado: searchValue, qtd, page })
      return result.data
    },
    altera (value) {
      if (value && value.uf) this.$emit('change', value.uf)
      else this.$emit('change', null)
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="obj"
    field="uf"
    width="1000"
    component="app-estado-grid"
    label="UF"
    @change="altera"
    :autocomplete="autocomplete" />
</template>
